module.exports = __webpack_public_path__ + "img/idcardHandUrl.2932fe46.png";